<%= turbo_stream.remove @clip %>
